import { RichText } from 'prismic-reactjs';
import { Accordion, AccordionItem, AccordionPanel } from 'remote-com-shared/components/Accordion';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import styled from 'styled-components';

import { transformProperties } from '@/src/domains/prismic/helpers';
import {
  FAQAccordionHeader,
  FAQSectionWrapper,
  FAQRichTextWrapper,
  FAQTitleComponent,
} from '@/src/views/ContractorManagement/styles';

const AdditionalContainer = styled(ContentContainer)`
  padding-top: 70px;
`;

export const CtaLink = styled.a`
  color: var(--colors-irisBlue);
  font-family: var(--typography-fontBrand);
  padding-bottom: 2px;
  border-bottom: 1px solid var(--colors-irisBlue);

  &:hover {
    border-bottom: 2px solid var(--colors-irisBlue);
  }
`;

export const FAQSection = ({
  title,
  frequentlyAskedQuestions,
  ctaLink,
  ctaLabel,
  htmlSerializer,
  icon,
  ...props
}) => (
  <FAQSectionWrapper {...props}>
    <ContentContainer>
      {icon || null}
      {title ? (
        <RichText render={title} Component={FAQTitleComponent} />
      ) : (
        <FAQTitleComponent>{title ?? 'Frequently Asked Questions'}</FAQTitleComponent>
      )}

      <Accordion multiple>
        {frequentlyAskedQuestions.map(({ question, answer }, index) => (
          <AccordionItem key={index}>
            <FAQAccordionHeader position={index + 1}>
              {RichText.asText(question)}
            </FAQAccordionHeader>
            <AccordionPanel>
              <RichText
                render={answer}
                Component={FAQRichTextWrapper}
                htmlSerializer={htmlSerializer}
              />
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </ContentContainer>
    {ctaLink && ctaLabel && (
      <AdditionalContainer>
        <CtaLink target={ctaLink?.target} href={ctaLink?.url}>
          {ctaLabel}
        </CtaLink>
      </AdditionalContainer>
    )}
  </FAQSectionWrapper>
);

export function FAQSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, tone } = primary;
  const { fields: frequentlyAskedQuestions } = slice;

  return (
    <FAQSection title={title} $tone={tone} frequentlyAskedQuestions={frequentlyAskedQuestions} />
  );
}
